import { RefreshCw } from 'lucide-react'

interface PullToRefreshIndicatorProps {
  pullDistance: number
  isRefreshing: boolean
  progress: number
  shouldTrigger: boolean
}

export function PullToRefreshIndicator({
  pullDistance,
  isRefreshing,
  progress,
  shouldTrigger,
}: PullToRefreshIndicatorProps) {
  if (pullDistance === 0 && !isRefreshing) return null

  return (
    <div
      className="absolute top-0 left-0 right-0 flex justify-center items-center z-20 pointer-events-none"
      style={{
        transform: `translateY(${Math.min(pullDistance, 80)}px)`,
        transition: pullDistance === 0 ? 'transform 0.3s ease-out' : 'none',
      }}
    >
      <div className="bg-white rounded-full shadow-lg p-3 flex items-center justify-center">
        <RefreshCw
          className={`w-5 h-5 text-green-600 ${
            isRefreshing ? 'animate-spin' : ''
          }`}
          style={{
            transform: isRefreshing ? 'none' : `rotate(${progress * 360}deg)`,
            transition: isRefreshing ? 'none' : 'transform 0.1s ease-out',
          }}
        />
      </div>
      {shouldTrigger && !isRefreshing && (
        <div className="absolute -bottom-6 text-xs text-green-600 font-medium">
          Suelta para actualizar
        </div>
      )}
    </div>
  )
}
